import { getApi } from "./api_instance";

export const getSDG = async (dispatch) => {
    try {
      const response = await getApi({
        apiUrl: `/projects/api/sdg/demand/dashboard`,
        dispatch,
      });
      return response.data; 
    } catch (error) {
      throw error;
    }
  };